import { Popover, Space, Table, Tag } from 'antd'
import { forwardRef } from 'react'
import EditContact from '../editContact/editContact'
import NewContact from '../newContact/newContact'
import moment from 'moment'

const ContactTable = forwardRef((props, ref) => {
  const { data = [], setFresh } = props

  data.map((item) => {
    item.updated_at = moment(item.updated_at).format('YYYY-MM-DD HH:mm:ss')
    item.status = item.weight
  })

  const columns = [
    {
      title: '编号',
      dataIndex: 'id',
      key: 'id',
      width: 100,
    },
    {
      title: '图片',
      dataIndex: 'image',
      key: 'image',
      width: 100,
      render: (contact) => (
        <Popover
          content={
            <div>
              <img
                style={{ width: 200, height: 200 }}
                src={contact}
                alt="联系人二维码"
              />
            </div>
          }
        >
          <img
            style={{ width: 50, height: 50 }}
            src={contact}
            alt="联系人二维码"
          />
        </Popover>
      ),
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: '推荐权重',
      dataIndex: 'weight',
      key: 'weight',
      width: 100,
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status) => {
       return status === 0 ? (
         <Tag color="grey">未启用</Tag>
       ) : (
         <Tag color="green">启用中</Tag>
       )
      },
    },
    {
      title: '推荐次数',
      key: 'statistic',
      dataIndex: 'statistic',
      width: 100,
    },
    {
      title: '更新时间',
      key: 'updated_at',
      dataIndex: 'updated_at',
      width: 200,
    },
    {
      title: '操作',
      key: 'action',
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <EditContact info={record} setFresh={setFresh} />
        </Space>
      ),
    },
  ]
  return (
    <div style={{ backgroundColor: 'white', padding: '30px' }}>
      <div className="headTitle" style={{ padding: 0 }}>
        推荐联系方式列表
      </div>
      <div style={{ textAlign: 'right', marginBottom: '30px' }}>
        <NewContact setFresh={setFresh} />
      </div>
      <Table columns={columns} dataSource={data} pagination={false} />
    </div>
  )
})

export default ContactTable
